var _excluded = ["size", "color", "style", "className", "spin", "rotate"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classNames from 'classnames';
import * as React from 'react';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var FoxIconError1Core = function FoxIconError1Core(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false",
    role: "img"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M512 128a384 384 0 1 0 0 768A384 384 0 0 0 512 128zM42.688 512a469.312 469.312 0 1 1 938.624 0A469.312 469.312 0 0 1 42.688 512zM353.856 353.92c16.64-16.64 43.648-16.64 60.288 0L512 451.648 609.856 353.92a42.688 42.688 0 1 1 60.288 60.288l-97.792 97.92 97.792 97.792a42.688 42.688 0 1 1-60.288 60.352L512 572.288l-97.856 97.92a42.688 42.688 0 0 1-60.288-60.352L451.648 512 353.92 414.144a42.688 42.688 0 0 1 0-60.288z"
    })
  }));
};
var Memo = /*#__PURE__*/memo(FoxIconError1Core);
/**
 * ![FoxIconError1](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCI+PHBhdGggZD0iTTUxMiAxMjhhMzg0IDM4NCAwIDEgMCAwIDc2OEEzODQgMzg0IDAgMCAwIDUxMiAxMjh6TTQyLjY4OCA1MTJhNDY5LjMxMiA0NjkuMzEyIDAgMSAxIDkzOC42MjQgMEE0NjkuMzEyIDQ2OS4zMTIgMCAwIDEgNDIuNjg4IDUxMnpNMzUzLjg1NiAzNTMuOTJjMTYuNjQtMTYuNjQgNDMuNjQ4LTE2LjY0IDYwLjI4OCAwTDUxMiA0NTEuNjQ4IDYwOS44NTYgMzUzLjkyYTQyLjY4OCA0Mi42ODggMCAxIDEgNjAuMjg4IDYwLjI4OGwtOTcuNzkyIDk3LjkyIDk3Ljc5MiA5Ny43OTJhNDIuNjg4IDQyLjY4OCAwIDEgMS02MC4yODggNjAuMzUyTDUxMiA1NzIuMjg4bC05Ny44NTYgOTcuOTJhNDIuNjg4IDQyLjY4OCAwIDAgMS02MC4yODgtNjAuMzUyTDQ1MS42NDggNTEyIDM1My45MiA0MTQuMTQ0YTQyLjY4OCA0Mi42ODggMCAwIDEgMC02MC4yODh6Ij48L3BhdGg+PC9zdmc+) 
 **/
export default function FoxIconError1(_ref) {
  var size = _ref.size,
    color = _ref.color,
    style = _ref.style,
    className = _ref.className,
    spin = _ref.spin,
    rotate = _ref.rotate,
    rest = _objectWithoutProperties(_ref, _excluded);
  var svgStyle = React.useMemo(function () {
    return rotate ? {
      msTransform: "rotate(".concat(String(rotate), "deg)"),
      transform: "rotate(".concat(String(rotate), "deg)")
    } : undefined;
  }, [rotate]);
  var customStyle = React.useMemo(function () {
    var tmp = {};
    if (size !== undefined) {
      tmp.fontSize = size;
    }
    if (color !== undefined) {
      tmp.color = color;
    }
    return tmp;
  }, [size, color, rotate]);
  var realStyle = React.useMemo(function () {
    if (style) {
      return _objectSpread(_objectSpread({}, customStyle), style);
    }
    return customStyle;
  }, [style, customStyle]);
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
    role: "img",
    className: classNames("appicon app_icon", className, spin ? "appicon-spin" : ""),
    style: realStyle
  }, rest), {}, {
    children: /*#__PURE__*/_jsx(Memo, {
      style: svgStyle
    })
  }));
}